import { EtablissementDto } from '@common/services';
import { buildPageableParams } from '../common';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';
import { RevisionDto } from '../revision';
import { servicesApi } from '../services';

const etablissementRevisionsApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({

    getAllEtablissementRevisions: build.query<RevisionDto[], GetEtablissementRevisionsQueryArgs, any>({
      queryFn: ({ id }, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: `etablissements/${id}/revisions`,
        params: buildPageableParams({
          size: 30,
          sorters: [{ field: 'originalId.REV.id', direction: 'desc' }],
        }),
      }),
    }),

    getEtablissementRevision: build.query<EtablissementDto, GetEtablissementRevisionQueryArgs, any>({
      query: ({ id, revisionId }) => ({
        url: `etablissements/${id}/revisions/${revisionId}/dto`,
      }),
    }),
  }),
});

interface GetEtablissementRevisionsQueryArgs {
  id: number;
}

interface GetEtablissementRevisionQueryArgs {
  id: number;
  revisionId: number;
}


export const {
  useGetAllEtablissementRevisionsQuery,
  useGetEtablissementRevisionQuery,
} = etablissementRevisionsApi;